import React, { ComponentProps } from 'react'
import { Text } from 'components/Text'
import { Option } from './TextRadioOption.styles'
import { Stack } from 'components/Stack'

type RadioOptionOwnProps = ComponentProps<typeof Option>

export type TextRadioOptionProps = RadioOptionOwnProps & {
  label: string
  value: string
  subtext?: string
}

export const TextRadioOption = ({ label, value, ...rest }: TextRadioOptionProps) => {
  return (
    <Option id={value} value={value} {...rest}>
      <Stack direction="column" alignItems="flex-start" justifyContent="center" gap={rest.subtext ? "1": "0"}>
        <Text align="left" htmlFor={value} as="label" size="h4" weight="regular">
        {label}
      </Text>
      <Text color="accent-black" size="small" align="left" >
        {rest.subtext}
      </Text>
      </Stack>
    </Option>
  )
}

TextRadioOption.displayName = 'TextRadioOption'
